import React, { useState } from 'react';
import axios from 'axios';
import Menu from './Menu';
import '../CSS/PaiePage.css';  // Utilisation du même CSS
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
    Snackbar,
    Alert
} from '@mui/material';
import apiUrl from '../config';
import { useNavigate } from 'react-router-dom';

const AddUserForm = () => {
    const navigate = useNavigate();
    const [nom, setNom] = useState('');
    const [prenom, setPrenom] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('USER'); // Par défaut, rôle "USER"
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation des champs
        if (!nom || !prenom || !email || !role) {
            setNotification({ open: true, message: 'Tous les champs doivent être remplis.', severity: 'error' });
            return;
        }

        // Préparer les données à envoyer au backend
        const data = { nom, prenom, email, role };

        try {
            // Envoyer la requête au backend pour enregistrer l'utilisateur
            const token = localStorage.getItem('token'); // Assurez-vous que le token est dans le localStorage
            const response = await axios.post(`${apiUrl}/register`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,  // Assurez-vous d'ajouter le token si nécessaire
                },
            });

            setNotification({ open: true, message: response.data.message, severity: 'success' });

            // Effacer les champs après une soumission réussie
            setNom('');
            setPrenom('');
            setEmail('');
            setRole('USER'); // Réinitialiser le rôle à "USER"

            setTimeout(() => navigate('/ListeUtilisateurs'), 1000); // Redirection vers la liste des utilisateurs après succès
        } catch (error) {
            console.error("Erreur lors de l'enregistrement de l'utilisateur:", error);
            setNotification({ open: true, message: "Une erreur est survenue lors de l'enregistrement de l'utilisateur.", severity: 'error' });
        }
    };

    return (
        <div className="paie-container">
            <Menu /> {/* Utilisez le composant Menu ici */}
            <div className="content">
                <div className="header">
                    <Typography variant="h1" gutterBottom align="center" sx={{ color: '#1f6391', marginTop: '20px' }}>
                        Ajouter un utilisateur
                    </Typography>
                </div>
                <Container maxWidth="md">
                    <Box sx={{ mt: 4 }}>
                        <form onSubmit={handleSubmit} className="add-user-form">

                            {/* Titre du champ */}
                            <Typography variant="h6" className="input-title">
                                Nom
                            </Typography>
                            <TextField
                                variant="outlined"
                                fullWidth
                                value={nom}
                                onChange={(e) => setNom(e.target.value)}
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                                className="input-field"
                            />

                            {/* Titre du champ */}
                            <Typography variant="h6" className="input-title">
                                Prénom
                            </Typography>
                            <TextField
                                variant="outlined"
                                fullWidth
                                value={prenom}
                                onChange={(e) => setPrenom(e.target.value)}
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                                className="input-field"
                            />

                            {/* Titre du champ */}
                            <Typography variant="h6" className="input-title">
                                Email
                            </Typography>
                            <TextField
                                variant="outlined"
                                type="email"
                                fullWidth
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                                className="input-field"
                            />

                            {/* Titre du champ */}
                            <Typography variant="h6" className="input-title">
                                Rôle
                            </Typography>
                            <TextField
                                variant="outlined"
                                select
                                fullWidth
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                                className="input-field"
                            >
                                <MenuItem value="user">USER</MenuItem>
                                <MenuItem value="CDI">CDI</MenuItem>
                                <MenuItem value="admin">ADMIN</MenuItem>
                            </TextField>

                            <Button type="submit" variant="contained" color="primary" fullWidth>
                                Ajouter l'utilisateur
                            </Button>
                            <Button
                                variant="outlined"
                                fullWidth
                                sx={{ mt: 1 }}
                                onClick={() => navigate('/Utilisateurs')} // Redirige vers la liste des utilisateurs
                            >
                                Retour à la liste
                            </Button>
                        </form>
                    </Box>
                </Container>

                {/* Notifications */}
                <Snackbar
                    open={notification.open}
                    autoHideDuration={3000}
                    onClose={() => setNotification({ ...notification, open: false })}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Position en haut et au centre
                >
                    <Alert
                        severity={notification.severity}
                        sx={{
                            width: '100%',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                            borderRadius: '8px',
                        }}
                    >
                        {notification.message}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    );
};

export default AddUserForm;
